import { render, staticRenderFns } from "./foreign-base-select.vue?vue&type=template&id=34e2981b"
import script from "./foreign-base-select.vue?vue&type=script&lang=js"
export * from "./foreign-base-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports